export class PqrCustomerEntity{
     
id:string;
name: string;
lastName: string;
emails: string;
description: string;
identification: number;
creationDate: Date;
active: boolean;
userId: number;
ticket:string;
emailAnnexed:string;
ticketId:string;
status: string;
typeStatus: number;

    constructor () {}
}